import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import {
  AccountActionService,
  AccountService,
  LoadingService,
  LoginData,
  LoginResponse,
  MessageService,
  TwoFADialogService
} from '@core';
import { of } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: 'login.page.html',
  styleUrls: ['login.page.scss']
})
export class AccessLoginPage {

  form: FormGroup = new FormGroup({
    email: new FormControl(),
    password: new FormControl()
  });

  constructor(
    private router: Router,
    private actionService: AccountActionService,
    private twoFADialogService: TwoFADialogService,
    private accountService: AccountService,
    private loadingService: LoadingService,
    private messageService: MessageService
  ) {}

  submit() {
    const { form, router, loadingService, messageService, accountService } = this;
    const data = form.value as LoginData;

    if (form.invalid) return;

    loadingService.start();

    accountService.login(data).subscribe({
      next: resp => {
        router.navigate(['/home']);
      },

      error: messageService.handle,

      complete: () => {
        loadingService.stop();
      }
    });
  }

}
